module.exports = __webpack_public_path__ + "static/img/layanan.52ff83e4.png";